import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { ILMSEmptyState } from '../components/ILMSEmptyState';
import { useAuth } from '../hooks/useAuth';

export default function NotFound() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-subtle p-4">
      <ILMSEmptyState
        icon={<Compass className="h-6 w-6" />}
        title="Page not found"
        description="The page you are looking for does not exist or may have moved."
        actionLabel={isAuthenticated ? 'Go to Dashboard' : 'Go to Homepage'}
        onAction={() => navigate(isAuthenticated ? '/dashboard' : '/')}
      />
    </div>
  );
}
